<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item  label="基地"  >
              <j-dict-select-tag placeholder="请选择部门" v-model="queryParam.inspectionBase" dictCode="bus_inspection_base,base,id,status = '1'" />
            </a-form-item>
          </a-col>
          <!-- <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item  label="违规部门"  >
              <j-dict-select-tag placeholder="请选择部门" v-model="queryParam.illegalDepart"  :dictCode="dictCodeIllegalDepart" />
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item  label="违规车间"  >
              <j-dict-select-tag placeholder="请选择部门" v-model="queryParam.illegalWorkshop" :dictCode="dictCodeIllegalWorkshop" />
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item  label="巡查部门"  >
              <j-dict-select-tag placeholder="请选择部门" v-model="queryParam.inspectionDepart" :dictCode="dictCodeInspectionDepart" />
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item  label="巡查车间"  >
              <j-dict-select-tag placeholder="请选择部门" v-model="queryParam.inspectionWorkshop" :dictCode="dictCodeInspectionWorkshop" />
            </a-form-item>
          </a-col> -->
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item  label="督查类型"  >
              <j-dict-select-tag placeholder="请选择督查类型" v-model="queryParam.actionType" dictCode="inspection_action_type" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('巡检行为督查曝光表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">
        <template slot="imgSlot" slot-scope="text, record,index">
          <a  @click="onShowPicture(text,record,index);" >图片</a>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">详情</a>

          <!-- <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>

      </a-table>
    </div>
    <div class="images1" v-viewer="{movable: false}"    >
      <img v-show="false" v-for='item in imageListData' :src="item" :key="item">
    </div>
    <busInspectionActionExposure-modal ref="modalForm" @ok="modalFormOk"></busInspectionActionExposure-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BusInspectionActionExposureModal from './modules/ActionExposureModal.vue'
  import { postAction } from '@/api/manage'
  export default {
    name: "BusInspectionActionExposureList",
    mixins:[JeecgListMixin],
    components: {
      BusInspectionActionExposureModal
    },
    data () {
      return {
        description: '巡检行为督查曝光表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          // {
          //   title:'删除状态',
          //   align:"center",
          //   dataIndex: 'delFlag'
          // },
          // {
          //   title:'主任务id',
          //   align:"center",
          //   dataIndex: 'taskId'
          // },
          // {
          //   title:'子任务id',
          //   align:"center",
          //   dataIndex: 'taskDetailId'
          // },
          {
            title:'检查人编码',
            align:"center",
            dataIndex: 'checkUserNo'
          },
          {
            title:'检查人姓名',
            align:"center",
            dataIndex: 'checkUserName'
          },
          // {
          //   title:'责任人编码',
          //   align:"center",
          //   dataIndex: 'workerUserNo'
          // },
          // {
          //   title:'责任人姓名',
          //   align:"center",
          //   dataIndex: 'workerUserName'
          // },
          {
            title:'行为督查类型',
            align:"center",
            dataIndex: 'actionType_dictText'
          },
          {
            title:'巡查地点',
            align:"center",
            customRender(text, record, index){
              return record.inspectionDepart+record.inspectionWorkshop
            }
          },
          {
            title:'违规部门',
            align:"center",
            dataIndex: 'illegalDepart'
          },
          {
            title:'违规车间',
            align:"center",
            dataIndex: 'illegalWorkshop'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remarks'
          },
          {
            title:'查看图片',
            align:"center",
            scopedSlots:{
              customRender:"imgSlot"
            },
            width:"120px",
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/busInspectionActionExposure/list",
          delete: "/busInspectionActionExposure/delete",
          deleteBatch: "/busInspectionActionExposure/deleteBatch",
          exportXlsUrl: "/busInspectionActionExposure/exportXls",
          importExcelUrl: "/busInspectionActionExposure/importExcel",
        },
        dictOptions:{},
        imageListData:[],
        dictCodeIllegalDepart:"",
        dictCodeIllegalWorkshop:"",
        dictCodeInspectionDepart:"",
        dictCodeInspectionWorkshop:"",

      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    mounted(){
      this.$set(this.queryParam,"illegalDepart","")
      this.$set(this.queryParam,"illegalWorkshop","")
      this.$set(this.queryParam,"inspectionDepart","")
      this.$set(this.queryParam,"inspectionWorkshop","")
    },
    methods: {
      initDictConfig(){
      },
      async onShowPicture(text,record,index){
        let params={
          orderId:record.taskDetailId,
          fileType:"image",
        }
        let pictureData=await  postAction("/inspection/api/file/findFileList",params)
        if(pictureData.result.length==0){
          this.$message.success("暂无图片")
          return
        }
        this.imageListData=[]
        pictureData.result.forEach(item=>{
          this.imageListData.push(item.fileUrl)
        })
        const viewer = this.$el.querySelector('.images1').$viewer
        viewer.show()  
      },
    },
    watch:{
      // "queryParam.inspectionBase"(value){
      //   this.queryParam.illegalDepart="";
      //   this.queryParam.illegalWorkshop="";
      //   this.queryParam.inspectionDepart="";
      //   this.queryParam.inspectionWorkshop="";
      //   console.log(value)
      //   if(!value){
      //     return
      //   }
      //   this.dictCodeIllegalDepart=`bus_inspection_base_depart,depart,id,base_id='${value}' AND status = '1'`
      //   this.dictCodeInspectionDepart=`bus_inspection_base_depart,depart,id,base_id='${value}' AND status = '1'`
      // },
      //  "queryParam.illegalDepart"(value){
      //    this.queryParam.illegalWorkshop="";
      //    if(!value){
      //      return
      //    }
      //   this.dictCodeIllegalWorkshop=`bus_inspection_depart_workshop,workshop,id,depart_id='${value}' AND status = '1'`
      // },
      //  "queryParam.inspectionDepart"(value){
      //    this.queryParam.inspectionWorkshop="";
      //    if(!value){
      //      return
      //    }
      //   this.dictCodeInspectionWorkshop=`bus_inspection_depart_workshop,workshop,id,depart_id='${value}' AND status = '1'`
      // }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>